module.exports = __webpack_public_path__ + "static/media/1-19.42b3a359.mp3";